import React from 'react';
import GPAP_Button from "../../gpap-lib/Button_Collection";

const dataToCsv = (csvData,headersCsv) => {
    // 1. Get Header Keys and Labels
    let headerKeys = headersCsv.map(row => { return row.key });
    let headerLabels = headersCsv.map(row => { return row.label });
    // 2. Build First Header Line
    let contents = '';
    contents += headerLabels.join(',');
    contents += '\n';
    // 3. Build CSV data
    csvData.forEach((rowItems) => {
        headerKeys.forEach((key) => {
            let value = rowItems[key];
            if (value === null) value = "";
            contents += value + ',';
        });
        if (contents.charAt(contents.length-1) === ",") contents = contents.slice(0,-1);
        contents += '\n';
    });
    return contents;
}

const downloadCSV = (csvData,headersCsv,nameFile) => {
    // 1. Get String of CSV Data
    let csv = dataToCsv(csvData,headersCsv);
    // 2. Format CSV
    csv = 'data:text/csv;charset=utf-8,' + csv;
    let data = encodeURI(csv);
    // 3. Force link
    let link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', nameFile);
    link.click();
}

const CsvButton = ({getCsvData}) => {
 return (
   <React.Fragment>
       <GPAP_Button className="btn btn-success mx-2 my-2" onClick={getCsvData}>
           <i className="fa fa-download" aria-hidden="true"/> Download Table to CSV
       </GPAP_Button>
   </React.Fragment>
 )
}

export {downloadCSV, CsvButton}
